// The register's matches for what has been typed, as the combo box's list.
//
// Someone who *sees* "Vitol SA" picks it rather than typing "Vitol S.A." beside it, which is what
// keeps a deal linked to the record instead of carrying a second spelling of its name.
//
// Nothing found renders no list. Whether that means "not on the register" is the field's to say,
// and only once the search has answered.

import { pickerMark } from '../../counterparties/labels.js';

export default function CounterpartySuggestions({ id, matches, active = -1, onPick }) {
  if (matches.length === 0) return null;

  return (
    <ul className="counterparty-suggestions" id={id} role="listbox">
      {matches.map((candidate, index) => (
        <li key={candidate.counterparty_id} role="option" aria-selected={index === active}>
          {/* mousedown is kept from moving focus, so the pick lands before anything else reacts
              to the input losing it. */}
          <button type="button" className={index === active ? 'active' : undefined}
                  tabIndex={-1}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => onPick(candidate)}>
            <span className="suggestion-name">{candidate.name}</span>
            {candidate.country && <span className="suggestion-detail">{candidate.country}</span>}
            {/* Marked, so picking one is an informed choice. A prospect or a rejected
                counterparty is a real record that links the deal; it is not on the approved
                list. */}
            {pickerMark(candidate.status) && (
              <span className="suggestion-status">{pickerMark(candidate.status).word}</span>
            )}
          </button>
        </li>
      ))}
    </ul>
  );
}
